import { Record } from 'immutable';

export const mkInvestmentIRR = Record({
  accountId: undefined,
  id: undefined,
  accountName: undefined,
  totalPerformance: undefined,
  status: undefined,
});
